import React from 'react';
import { Color } from 'lib/modelBuilder/entities/Color';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/PanesPanel/types';
import { makeSelectColors } from 'containers/Configurator/selectors/colors';
import { useDispatch, useSelector } from 'react-redux';
import ColorPickerList from 'components/ColorPickerList';
import { updateColorIntermediateShelvesOnSelectionAction } from 'containers/IntermediateShelfPanel/actions';
import {
  BLACK_COLOR,
  GLASS_COLOR,
  MIRROR_COLOR,
  NATURAL_COLOR,
  WHITE_COLOR,
} from 'lib/modelBuilder/constants';
import { setColorsPanelAction } from 'containers/Configurator/actions/general';

interface Props {
  commonColor: Color | undefined;
}

interface StateProps {
  colors: Color[];
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  colors: makeSelectColors(),
});

const ISColorPicker = ({ commonColor }: Props) => {
  const dispatch = useDispatch();
  const { colors } = useSelector(stateSelector);

  const colorSelected = (color: Color, preview: boolean) => {
    dispatch(updateColorIntermediateShelvesOnSelectionAction(color, preview));
  };

  const filterColor = (color: Color) => {
    /**
     * Only white, black, glass and MDF Natural
     */
    return (
      color.reference === GLASS_COLOR ||
      color.reference === NATURAL_COLOR ||
      color.reference === BLACK_COLOR ||
      color.reference === WHITE_COLOR
    );
  };

  const onClickColor = (color: Color) => {
    colorSelected(color, false);
  };

  const onMouseOverColor = (color: Color) => {
    colorSelected(color, true);
  };

  if (colors) {
    return (
      <ColorPickerList
        colors={colors.filter(color => filterColor(color))}
        onClick={onClickColor}
        onMouseOver={onMouseOverColor}
        selectedColor={commonColor}
        onDoubleClick={() => {
          dispatch(setColorsPanelAction());
        }}
        bigColors={[]}
      />
    );
  } else return null;
};

export default ISColorPicker;
